// Who may see the developer console.
//
// PURE. The page used to decide this inside an effect, which runs AFTER the
// first paint, so every other signed-in user saw Create Organization for
// one frame before the redirect.
export const ALLOWED_ADMIN_EMAILS = new Set(['benwilcox101@gmail.com']);

export function isDevConsoleAllowed(user) {
  const email = user && user.email && user.email.toLowerCase();
  return Boolean(email && ALLOWED_ADMIN_EMAILS.has(email));
}

export default isDevConsoleAllowed;
